var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 60,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 35,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.093,
    x2: 44.001,
    y1: 80.547,
    y2: 64.501
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.8,
    x2: 75.91,
    y1: 55.6,
    y2: 39.545
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2e8c3be26393f53c74eba78b10262361.svg";
export { ForwardRef as ReactComponent };